import { render } from "./StatusReservation.vue?vue&type=template&id=7bbbea8f&scoped=true&ts=true"
import script from "./StatusReservation.vue?vue&type=script&lang=ts"
export * from "./StatusReservation.vue?vue&type=script&lang=ts"

import "./StatusReservation.vue?vue&type=style&index=0&id=7bbbea8f&scoped=true&lang=scss"

import exportComponent from "D:\\Proyectos\\mytransfers-extranet-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbbea8f"]])

export default __exports__